import {
  NoConfirmationDefaultNavigatorConfiguration,
  NoConfirmationPreQualifiedCustomerNavigatorConfiguration
} from "../../App/Compositions/NavigatorConfigurations";
import {
  noConfirmationCenterSelectableBookingStepConfigurations,
  screeningStepConfigurations
} from "../../App/Compositions/StepConfigurations";
import { Flow } from "../../Types/IFlow";

const noWelcomeNoBookFlowName = "NoWelcomeNoBookFlow";

/** Legacy flow name alias. Routes users with cached "NoWelcomeNoBookFlow" sessions to the no-confirmation experience. */
class NoWelcomeNoBookFlow extends Flow {
  static readonly flowName = noWelcomeNoBookFlowName;

  constructor(isCustomerPreQualified: boolean) {
    isCustomerPreQualified
      ? super(
          noWelcomeNoBookFlowName,
          { ...noConfirmationCenterSelectableBookingStepConfigurations },
          NoConfirmationPreQualifiedCustomerNavigatorConfiguration
        )
      : super(
          noWelcomeNoBookFlowName,
          { ...screeningStepConfigurations, ...noConfirmationCenterSelectableBookingStepConfigurations },
          NoConfirmationDefaultNavigatorConfiguration
        );
  }
}

export default NoWelcomeNoBookFlow;
